import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Solicitacao } from '@/types/solicitacao';
import { useClientFilter } from '@/hooks/useClientFilter';

export const useOpenTickets = (enabled: boolean = false) => {
  const { getClientFilter, clientLoading } = useClientFilter();
  const clientId = getClientFilter();

  return useQuery({
    queryKey: ['open-tickets', clientId],
    queryFn: async () => {
      let query = supabase
        .from('solicitacoes')
        .select(`
          *,
          categoria:categorias_servico(nome),
          solicitante:users!solicitacoes_solicitante_id_fkey(name),
          cliente:clients(name),
          grupo_responsavel:groups(name),
          atendente:users!solicitacoes_atendente_id_fkey(name)
        `)
        .not('status', 'eq', 'fechada')
        .order('criado_em', { ascending: false });

      if (clientId) {
        query = query.eq('client_id', clientId);
      }

      const { data, error } = await query;
      if (error) throw error;
      return (data || []) as Solicitacao[];
    },
    enabled: enabled && !clientLoading,
  });
};
